import React, {useEffect, useState, useCallback} from "react";
import PageContainer from "../../layouts/PageContainer";
import Swal from "sweetalert2";
import {Grid} from "@material-ui/core";
import BannerList from "./BannerList";
import {helpers} from "../../helper/helper";

import {useSnackbar} from "notistack";

const Banner = () => {
    const {enqueueSnackbar} = useSnackbar();
    const [giftsList, setGiftsList] = useState();
    const [check, setCheck] = useState(true);
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
      };
    

    const GiftsData = useCallback(async () => {
        try {
            const url = "banners";
            const result = await helpers.apiCall("GET", url);
            setGiftsList(
            result && result.data && result.data.result ? result.data.result : []
            );
        } catch (error) {
            setGiftsList([]);
            console.error("error", error);
        }
    }, [setGiftsList]);

    useEffect(() => {
        GiftsData();
    }, [GiftsData]);

    const deleteGifts = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f50057",
            cancelButtonColor: "#263273",
            confirmButtonText: "Yes, delete it!",
          }).then(async (result) => {
            if (result.value) {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              const url = `banners/${id}`;
              const result = await helpers.apiCall("DELETE", url);
              if (result.status === 200) {
                  GiftsData();
                  handleClose();
                  enqueueSnackbar("Banner Deleted successfully", {
                      variant: 'success',
                      autoHideDuration: 3000,
                  });
              }
              else {
                  enqueueSnackbar(result.data ? result.data.message : result.message, {
                      variant: 'error',
                      autoHideDuration: 3000,
                  });
              }
            }
          });
       
    };

    return (
        <PageContainer pageheading="BANNER">
            <Grid container spacing={3}>
                <Grid item sm={12} xs={12}>
                    <BannerList
                        giftsList={giftsList}
                        deleteGifts={deleteGifts}
                        setCheck={setCheck}
                        check={check}
                        setOpen={setOpen}
                        open={open}
                        handleClose={handleClose}
                    />
                </Grid>
            </Grid>
        </PageContainer>
    );
};

export default Banner;
